import { Progress } from "@/components/ui/progress";

interface CharacterGuidanceProps {
  currentLength: number;
  minLength: number;
  maxLength: number;
}

const getMotivationalMessage = (length: number, minLength: number, maxLength: number) => {
  if (length === 0) {
    return "Start writing...";
  }
  
  if (length < minLength) {
    const remaining = minLength - length;
    return `${remaining} more to continue`;
  }
  
  if (length >= maxLength) {
    return "Maximum reached";
  }
  
  return "Looking good";
};

const getProgressColor = (length: number, minLength: number, maxLength: number) => {
  if (length < minLength) return "bg-muted-foreground/30";
  if (length >= maxLength) return "bg-destructive";
  
  const percentage = (length / maxLength) * 100;
  if (percentage < 50) return "bg-primary";
  if (percentage < 75) return "bg-primary";
  if (percentage < 90) return "bg-primary";
  return "bg-warning";
};

export const CharacterGuidance = ({ currentLength, minLength, maxLength }: CharacterGuidanceProps) => {
  const percentage = Math.min((currentLength / maxLength) * 100, 100);
  const isValid = currentLength >= minLength && currentLength <= maxLength;
  const isAtMax = currentLength >= maxLength;
  
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span className={`transition-colors ${
          isValid ? 'text-primary' : isAtMax ? 'text-destructive' : ''
        }`}>
          {getMotivationalMessage(currentLength, minLength, maxLength)}
        </span>
        <span>
          {currentLength} / {maxLength}
        </span>
      </div>
      <Progress 
        value={percentage} 
        className="h-1"
      />
    </div>
  );
};
